import { ActionBrick, registerBrick, ErrorFlow } from 'olympe';

export default class RGProcessChangesForObjects extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<!RGChange>} changes
     * @param {boolean} inPlace
     * @param {Array} data
     * @param {function()} forwardEvent
     * @param {function(!ErrorFlow)} setErrorFlow
     */
    update(_$, [changes, inPlace, data], [forwardEvent, setErrorFlow]) {
        const errors = ['No changes applied because:'];
        changes.forEach(change => {
            if(!(change.metadata.newCell.validator?.(change.newValue) ?? true)) {
                errors.push(`This value is not valid: ${change.newValue}`);
            }
        });
        if(errors.length > 1) {
            setErrorFlow(ErrorFlow.create(errors.join('\n'), 1));
            return;
        }
        if(inPlace) {
            changes.forEach(change => {
                change.object[change.property] = change.newValue;
            });
        }
        else {
            changes.forEach(change => {
                data[change.metadata.rowId][change.property] = change.newValue;
            });
        }
        forwardEvent();
    }
}

registerBrick('01921e0d2b383c95bd22', RGProcessChangesForObjects);
